import { Directive, Input } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    NG_VALIDATORS,
    Validator,
    ValidatorFn,
} from '@angular/forms';

@Directive({
    selector: '[appNumberNegative]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NumberNegativeDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class NumberNegativeDirective implements Validator {
  @Input() number_negative = -1;
  validator: ValidatorFn;

  constructor() {
    this.validator = this.validateMinusKubunFactory();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  validateMinusKubunFactory(): ValidatorFn {
    return (c: AbstractControl) => {
      if (!c.value) {
        return null;
      }
      let str: number;
      if (typeof c.value === 'number') {
        str = c.value;
      }
      if (typeof c.valid === 'object') {
        str = c.value[0];
      }
      if (!str) {
      }
      if (this.number_negative === 1) {
        return null;
      }
      if (this.number_negative === 0) {
        if (str && str < 0) {
          return {
            number_negative: {
              valid: false,
            },
          };
        }
      }
      return null;
    };
  }
}
